import { render, staticRenderFns } from "./NormalSelect.vue?vue&type=template&id=024c8cdc&"
import script from "./NormalSelect.vue?vue&type=script&lang=js&"
export * from "./NormalSelect.vue?vue&type=script&lang=js&"
import style0 from "./NormalSelect.vue?vue&type=style&index=0&scope=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports